import { debounce } from "../shared/scripts/debounce";

export const initializeCookiePreferences = () => {
    document.addEventListener("DOMContentLoaded", () => {
        const cookieLevelRangeElem = document.getElementById("CookieLevelSelected") as HTMLInputElement;
        if (!cookieLevelRangeElem) return;

        const levelSelectionContainer = document.querySelector(".cookie-level-selectors");
        if (!levelSelectionContainer) return;

        const levelSelectionElems = levelSelectionContainer.querySelectorAll(".cookie-level");

        const setRangeHeight = () => {
            if (levelSelectionElems.length > 0) {
                const firstElem = levelSelectionElems[0] as HTMLElement;
                const lastElem = levelSelectionElems[levelSelectionElems.length - 1] as HTMLElement;
                const verticalDistance = lastElem.offsetTop - firstElem.offsetTop;
                cookieLevelRangeElem.parentElement?.setAttribute("style", `--range-height: ${verticalDistance + 36}px`);
            }
        };

        const handleLevelClick = (event: Event) => {
            const target = (event.target as HTMLElement).closest(".cookie-level") as HTMLElement;
            if (!target) return;

            const index = Array.from(levelSelectionElems).indexOf(target);
            if (index !== -1) {
                cookieLevelRangeElem.value = (index + 1).toString();
                cookieLevelRangeElem.setAttribute("data-value", cookieLevelRangeElem.value);
            }
        };

        const handleRangeClick = () => {
            requestAnimationFrame(() => {
                cookieLevelRangeElem.setAttribute("data-value", cookieLevelRangeElem.value);
            });
        };

        // Set the data-value attribute based on the initial value of cookieLevelRangeElem
        cookieLevelRangeElem.setAttribute("data-value", cookieLevelRangeElem.value);
        levelSelectionContainer.addEventListener("click", handleLevelClick);
        cookieLevelRangeElem.addEventListener("click", handleRangeClick);

        const debouncedSetRangeHeight = debounce(setRangeHeight, 100);
        const resizeObserver = new ResizeObserver(debouncedSetRangeHeight);
        resizeObserver.observe(levelSelectionContainer);

        setRangeHeight();
    });
};

initializeCookiePreferences();
